import * as React from 'react';
import classNames from 'classnames';
import styles from './ButtonSimple.module.css';
export default function ButtonSimple(_a) {
    var _b;
    var _c = _a.status, status = _c === void 0 ? 'enabled' : _c, title = _a.title, onClick = _a.onClick, style = _a.style, _d = _a.color, color = _d === void 0 ? 'blue' : _d, _e = _a.type, type = _e === void 0 ? 'button' : _e;
    return (React.createElement("button", { type: type, className: classNames(styles.button, styles["button--".concat(color)], (_b = {},
            _b[styles.disabled] = status === 'disabled',
            _b)), disabled: status !== 'enabled', onClick: onClick, style: style }, title));
}
